<!--
 * @Author: fengxiaojing
 * @LastEditTime: 2024-09-30 16:28:48
 * @Description:
 * @LastEditors: Please set LastEditors
-->
<template>
  <div
    v-if="showMenu"
    class="RightClickMenu absolute py-10px px-10px"
    :style="{ top: `${currentMouseLocation.y}px`, left: `${currentMouseLocation.x}px` }"
  >
    <div class="menu_list">
      <div
        class="text-[#fff] text-14px pb-5px cursor-pointer px-8px py-4px"
        :class="
          activeItem === item.id
            ? 'active_class'
            : activeMouseItem === item.id
            ? 'active_class'
            : ''
        "
        v-for="item in menuList"
        :key="item.id"
        @click="handleClickMenu(item)"
        @mouseenter="handlerMouseenter(item)"
        @mouseleave="handlerMouseleave(item)"
      >
        {{ item.label }}
      </div>
    </div>
  </div>
</template>

<script>
const baseUrl = Wiz.GetModuleServer()
const menu1 = [
  {
    id: 0,
    label: '附近监控',
  },
  {
    id: 1,
    label: '设备属性',
  },
]
const menu2 = [
  {
    id: 0,
    label: '附近监控',
  },
  {
    id: 1,
    label: '设备属性',
  },
  {
    id: 2,
    label: '设备诊断',
  }
]

export default {
  name: 'RightClickMenu',
  data() {
    return {
      posInfo: {
        pos: [],
        code: '',
      },
      currentMouseLocation: {
        x: 0,
        y: 0,
      },
      activeItem: -1,
      activeMouseItem: -1,
      menuList: [
        {
          id: 0,
          label: '附近监控',
        },
        {
          id: 1,
          label: '设备属性',
        },
      ],
      showMenu: false,
      mianDeviceData: [],
      allDeviceData: [],
      rClickData: null,
    }
  },
  props: {
    player: {
      type: Object,
      defalut: () => {
        return {}
      },
    },
  },
  computed: {
    clientWidth() {
      return document.documentElement.clientWidth
    },
    clientHeight() {
      return document.documentElement.clientHeight
    },
    getKksCode() {
      return (kksCode) => {
        const prefix = kksCode.slice(0, 4)
        if (prefix === '6760') {
          return kksCode.slice(4, kksCode.length)
        }
        return kksCode
      }
    },
  },
  async created() {},
  async mounted() {
    if (!_.isEmpty(this.player)) {
      this.player.Native.ModelTree.EventBrowseRClick.connect(this.rightClickMsg)
      const playerDemo = document.getElementById('playerEngineId')
      playerDemo.addEventListener('click', this.handleModelDemoClick)
      this.getMainDeviceData()
      const deviceCount = await this.getAllDeviceData(1, false)
      if (deviceCount > 0) {
        this.getAllDeviceData(deviceCount, true)
      }
    }
  },
  methods: {
    /**
     * @description: 右键点击事件
     * @param {*} data
     * @return {*}
     */
    async rightClickMsg(data) {
      this.rClickData = data
      if (data && !data.object) {
        this.showMenu = false
        return
      }
      const code = await this.getDeviceCode(this.rClickData.object.item)
      this.rClickData.object.code = code ?? ''
      // if (!this.rClickData.object.code) {
      //   code = await this.getDeviceCode(this.rClickData.object.parentItem)
      //   if (code) {
      //     this.rClickData.object.code = code
      //   }
      // }
      if (this.rClickData.object.code) {
        const existItem = this.mianDeviceData.find((item) => {
          return this.getKksCode(item.code) === this.getKksCode(this.rClickData.object.code)
        })
        if (existItem) {
          this.rClickData.object.existItem = existItem
          this.menuList = menu2
        } else {
          this.menuList = menu1
        }
      } else {
        this.menuList = menu1
      }
      this.activeItem = -1
      this.activeMouseItem = -1
      this.posInfo.pos = data.pos || []
      this.posInfo.code = data.object.code || ''
      // 获取可视区域的高度+宽度
      this.currentMouseLocation = {
        x: data.screen[0],
        y: data.screen[1],
      }
      this.showMenu = true
    },
    // 递归获取设备code
    async getDeviceCode(item) {
      const itemInfo = await this.player.Native.ModelTree.getItemInfo(item)
      if (!itemInfo.code && !!itemInfo.parentItem) {
        const deviceCode = await this.getDeviceCode(itemInfo.parentItem)
        return deviceCode
      }
      if (itemInfo.code) {
        // 先从主要设备列表中查找
        let existItem = this.mianDeviceData.find((mainDevice) => {
          return this.getKksCode(mainDevice.code) === this.getKksCode(itemInfo.code)
        })
        if (existItem) {
          return itemInfo.code
        }
        if (!existItem) {
          // 如果主要设备列表中没有找到，则从全部设备列表中查找
          existItem = this.allDeviceData.find((device) => {
            return this.getKksCode(device.code) === this.getKksCode(itemInfo.code)
          })
          if (existItem) {
            return itemInfo.code
          }
        }
        // 如果都没找到，则查找父级设备
        if (!existItem && itemInfo.parentItem) {
          return this.getDeviceCode(itemInfo.parentItem)
        }
      }
      return undefined
    },

    /**
     * @description: 点击事件
     * @param {*} data
     * @return {*}
     */
    async handleClickMenu(data) {
      this.activeItem = data.id
      if (data.label === '附近监控') {
        const openEvent = new CustomEvent('openComponent', {
          detail: {
            toCom: {
              code: 'NearbyCameras',
              origin: 'tag',
              name: '监控列表',
            },
            type: 'tags',
            props: this.posInfo,
          },
        })
        window.dispatchEvent(openEvent)
      } else if (data.label === '设备属性') {
        if (this.rClickData?.object?.existItem) {
        // 设备列表中存在点击的设备，打开右侧面板显示全部tab菜单
          this.$emit('transferEvent', {
            toCom: { code: 'DeviceRealBasicInfo', origin: 'DeviceLedger', name: '设备基础信息' },
            type: 'mainComponent',
            props: this.rClickData.object.existItem,
          })
        } else {
        // 设备列表中不存在点击的设备，打开右侧面板仅显示设备属性tab菜单
          this.$emit('transferEvent', {
            toCom: { code: 'DeviceInfo', origin: 'DeviceLedger', name: '设备属性' },
            type: 'mainComponent',
            props: {
              code: this.rClickData.object.code,
              onlyDeviceProp: true,
            },
          })
        }
      } else if (data.label === '设备诊断') {
        this.$emit('transferEvent', {
          toCom: { code: 'DeviceDiagnosticsDetail', origin: 'DeviceDiagnostics', name: '设备诊断信息' },
          type: 'mainComponent',
          props: this.rClickData.object.existItem,
        })
      }
      // 点击菜单按钮之后关闭菜单
      this.showMenu = false
    },

    // 鼠标移入
    handlerMouseenter(data) {
      this.activeMouseItem = data.id
    },
    // 鼠标移出
    handlerMouseleave(data) {
      this.activeMouseItem = -1
    },
    // 云渲染模型点击事件
    handleModelDemoClick(event) {
      const ePathList = event.path
      const isRouterView = _.findIndex(ePathList, (item) => {
        return item.className === 'RightClickMenu absolute p-10px'
      })
      if (isRouterView === -1) {
        this.showMenu = false
      }
      event.preventDefault()
    },
    // 获取设备列表
    async getDeviceData(params) {
      const res = await axios({
        method: 'GET',
        url: `${baseUrl}/openapi/devices/paged-list/V1.0?token=portal_js`,
        params,
        headers: {
          'Content-Type': 'application/json; charset=utf8',
        },
        responseType: 'json',
      })
      return res
    },
    // 获取主要设备列表
    async getMainDeviceData() {
      const params = {
        pageNo: 1,
        pageSize: 9999,
        level: 'A,B',
      }
      const res = await this.getDeviceData(params)
      if (res.data.code === 200) {
        this.mianDeviceData = res.data.data.items
      }
    },
    // 获取全部设备列表
    async getAllDeviceData(pageSize, isRealRequest) {
      const params = {
        pageNo: 1,
        pageSize
      }
      const res = await this.getDeviceData(params)
      if (res.data.code === 200) {
        if (isRealRequest) {
          this.allDeviceData = res.data.data.items
        } else {
          return res.data.data.totalCount
        }
      } else {
        return 0
      }
      return ''
    },
  },
  beforeDestroy() {
    const playerDemo = document.getElementById('playerEngineId')
    if (playerDemo) {
      playerDemo.removeEventListener('click', this.handleModelDemoClick)
    }
    if (this.player && this.player.Native) {
      this.player.Native.ModelTree.EventBrowseRClick.disconnect(this.rightClickMsg)
    }
  },
}
</script>
<style lang="scss" scoped>
.RightClickMenu {
  border-radius: 4px;
  background-color: #0b252d !important;
  z-index: 110;
}
.menu_list {
  border-radius: 4px;
  background-color: #1d444b !important;
}
.active_class {
  background-color: rgba(0, 116, 201, 0.4);
  color: #00c0ff !important;
}
</style>
